<div class="question-tag" [title]="sourceQuestion.trailStr">
  @if (sourceQuestion.isGlobal) {
  <span>🌐</span>
  }
  <span class="ui circular label type-label">
    <span>{{ getType(sourceQuestion) }}</span>
  </span>
  @if (showQuestionId) {
  <span class="question-text">{{
    prefix
      ? prefix + sourceQuestion.id + ". " + sourceQuestion.question
      : +sourceQuestion.id + ". " + sourceQuestion.question
  }}</span>
  } @if (!showQuestionId) {
  <span class="question-text">{{
    prefix ? prefix + sourceQuestion.question : sourceQuestion.question
  }}</span>
  } @if (sourceQuestion.inGroup) {
  <i class="ui redo icon"></i>
  } @if (sourceQuestion.isTableColumn) {
  <i class="ui redo icon"></i>
  }
</div>
